import { useQuery } from "@tanstack/react-query";
import { getReportTemplates as getReportTemplatesService } from "services/ReportTemplates.services";

export default function useReportTemplates() {
  const reportTemplates = useQuery({
    queryKey: ["reportTemplates"],
    queryFn: getReportTemplatesService,
  });

  return {
    reportTemplates: reportTemplates.data?.resultList,
    isLoadingReportTemplates: reportTemplates.isLoading,
    isFetchingReportTemplates: reportTemplates.isFetching,
  };
}
